class CustomABTesting extends HTMLElement {
  constructor() {
    super();
    this.abtestkey = this.getAttribute("data-abtest-key");
    this.abtestvalue = this.getAttribute("data-abtest-value");
  }

  connectedCallback() {
    this.initABTest();
  }

  initABTest() {
    if (this.abtestkey && this.abtestvalue) {
      this.addABTestToCartAttributes(this.abtestkey, this.abtestvalue);
    }
  }

  addABTestToCartAttributes(key, value) {
      try {
        fetch('/cart.js', {})
          .then(function (res) { return res.json(); })
          .then(data => {
            if (data.attributes[key]) {
              console.log('testabalreadyset');
            } else {
              this.postABTestValue(key, value);
            }
          });
      } catch (error) {
        console.log(error);
      }
  }

  postABTestValue(key, value) {
    try {
      let postData = {};
      const attributesString = `{ "${key}" : "${value}" }`;

      postData["attributes"] = JSON.parse(attributesString);

      const headers = {
        "Content-Type": "application/json",
      };

      axios
        .post('/cart/update.js', postData, { headers })
        .then(({ data }) => {
          //console.log(data);
        })
    } catch (error) {
      console.log(error);
    }
  }
}


customElements.define("custom-abtesting", CustomABTesting);
